module.exports = __webpack_public_path__ + "f321d41c48b0e2efdc1eeae7346d1788.png";